module.exports = __webpack_public_path__ + "img/s6Model3.880d1035.webp";